import { PricingModelRead } from 'src/common/external/bambi-api/bambiApi';

export const emptyDefaultPricingModelDetailsDraft: PricingModelRead = {
  name: '',
  details: '',
  is_default: false,
  pricing_types: [],
  pricing_condition: {},
};
